import { IconFont } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    background-color: var(--color-white);
`

export const Content = styled.div`
    width: 100%;
    height: 100%;
    min-height: 0;
    display: flex;
    background-color: var(--color-gray-100);
`

export const Main = styled.div`
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export const HistoryBar = styled.div`
    flex-shrink: 0;
    padding: 12px 20px 0;
    background-color: var(--color-gray-100);
`

export const HistoryScroll = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    padding-bottom: 8px;

    &::-webkit-scrollbar {
        height: 6px;
    }
`

export const HistoryItem = styled.button<{ $active: boolean }>`
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    gap: 6px;
    height: 30px;
    padding: 0 10px;
    border-radius: 6px;
    border: 1px solid var(--color-gray-200);
    background-color: var(--color-white);
    color: var(--color-gray-700);
    cursor: pointer;
    white-space: nowrap;

    ${({ $active }) =>
        $active &&
        css`
            border-color: #1f144c;
            background-color: #1f144c;
            color: var(--color-white);
        `}
`

export const HistoryName = styled.span`
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
`

export const HistoryClose = styled(IconFont)`
    flex-shrink: 0;
    cursor: pointer;
`

export const OutletWrapper = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`
